import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import { selectMyPortfolioCapsulesState } from '../selectors';
import {
    initialMyPortfolioCapsulesConfigState,
    MyPortfolioCapsulesWidgetConfigState,
} from './MyPortfolioCapsulesWidgetConfigState';

export const buildMyPortfolioCapsulesConfigSlice = () =>
    buildConfigSlice<MyPortfolioCapsulesWidgetConfigState>(
        WidgetType.MY_PORTFOLIO_CAPSULES,
        selectMyPortfolioCapsulesState,
        initialMyPortfolioCapsulesConfigState,
        upgradeConfig
    );

export const useMyPortfolioCapsulesConfigSlice = () =>
    useConfigSlice(buildMyPortfolioCapsulesConfigSlice());

export type MyPortfolioCapsulesConfigPayloadType =
    WidgetConfigSliceActionPayloadType<MyPortfolioCapsulesWidgetConfigState>;

export const useMyPortfolioCapsuleConfigSlice = <TConfig>() => {
    const { config, dispatchConfigChanged } = useConfigSlice(
        buildMyPortfolioCapsulesConfigSlice()
    );

    const capsuleConfig = config as unknown as TConfig;
    const dispatchCapsuleConfigChanged = dispatchConfigChanged as unknown as (
        delta: Partial<TConfig>
    ) => void;

    return {
        config: capsuleConfig,
        dispatchConfigChanged: dispatchCapsuleConfigChanged,
    };
};

function upgradeConfig(
    config: MyPortfolioCapsulesWidgetConfigState | undefined
): MyPortfolioCapsulesWidgetConfigState {
    const ret = config || initialMyPortfolioCapsulesConfigState;
    if (ret.aggregationKey === undefined) {
        ret.aggregationKey = 'allValid';
    }
    return ret;
}
